import React, { ReactNode } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Login } from '_templates';
import { LOGIN_TYPES } from '_templates/Login/constants';
import history from 'helpers/history';
import { resetAuthorizeReducer } from 'store/reducers/authorizeReducer';
import { resetJobReducer } from 'store/reducers/jobReducer';
import { resetCommonReducer } from 'store/reducers/commonReducer';
import { resetCandidateReducer } from 'store/reducers/candidateReducer';
import { resetDashboardReducer } from 'store/reducers/dashboardReducer';
import { ROUTES } from 'router/constants';

interface ErrorBoundaryDispatchProps {
  resetAuthReducer: () => void;
  resetCandidateReducer: () => void;
  resetCommonReducer: () => void;
  resetDashboardReducer: () => void;
  resetJobReducer: () => void;
}

interface ErrorBoundaryProps extends ErrorBoundaryDispatchProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(): void {
    if (process.env.NODE_ENV !== 'production' || window.location.hostname === 'dev.ats.leverx-group.com') return;
    this.props.resetAuthReducer();
    this.props.resetCandidateReducer();
    this.props.resetCommonReducer();
    this.props.resetDashboardReducer();
    this.props.resetJobReducer();
    window.localStorage.removeItem('access_token');
    history.push(ROUTES.LOGIN, { error: LOGIN_TYPES.APP_CRASH });
    this.setState({ hasError: true });
  }

  render(): ReactNode {
    if (this.state.hasError) return <Login clearError={() => this.setState({ hasError: false })} />;
    return this.props.children;
  }
}

const mapDispatchToProps = (dispatch: Dispatch): ErrorBoundaryDispatchProps => ({
  resetAuthReducer: bindActionCreators(resetAuthorizeReducer, dispatch),
  resetCandidateReducer: bindActionCreators(resetCandidateReducer, dispatch),
  resetCommonReducer: bindActionCreators(resetCommonReducer, dispatch),
  resetDashboardReducer: bindActionCreators(resetDashboardReducer, dispatch),
  resetJobReducer: bindActionCreators(resetJobReducer, dispatch),
});

export default connect(undefined, mapDispatchToProps)(ErrorBoundary);
